const normalizeHost = (value?: string): string => {
  const trimmed = value?.trim();
  if (!trimmed) {
    return '';
  }

  try {
    return new URL(trimmed).hostname.toLowerCase();
  } catch {
    return (
      trimmed
        .replace(/^https?:\/\//i, '')
        .split('/')[0]
        ?.trim()
        .toLowerCase() || ''
    );
  }
};

export const getMaintenanceOverride = () => {
  const enabled = import.meta.env.VITE_MAINTENANCE_ENABLED || false;
  const targetHost = normalizeHost(import.meta.env.VITE_MAINTENANCE_TARGET_HOST);
  const currentHost = normalizeHost(window.location.hostname);
  const hostMatched = Boolean(targetHost) && currentHost === targetHost;
  const active = enabled && hostMatched;
  const message =
    import.meta.env.VITE_MAINTENANCE_MESSAGE?.trim() ||
    'Global EZTopup is temporarily unavailable due to maintenance. Please try again later.';

  return {
    active,
    enabled,
    hostMatched,
    targetHost,
    currentHost,
    message,
  };
};
